export const PRACTICE_CONFIGURATION_PYMENT_TYPES = {
  PHYSICAL_TERMINAL: 'Physical Terminal',
  VIRTUAL_TERMINAL: 'Virtual Terminal',
  PAYMENT_LINK: 'Payment Link',
  ACH_OR_E_CHECK: 'ACH/e-check',
  CHECK: 'Check',
  CASH: 'Cash',
  PAYMENT_PLAN: 'Payment Plan',
  SAVED_CARD: 'Payment Method on File',
};

export const PAYMENT_CONFIGURATION = {
  DoNotProcess: 'Do Not Process',
  AdditionalServiceFee: 'Additional Service Fee',
  //AllowPayNow: "Allow Pay Now",
  DisplayOrderForACHAndCC: 'Display order for ACH And CC',
  PaymentMethodForPMSWriteBack: 'Payment Method for PMS write-back',
  AllowPrePaymentCollection: 'Allow Pre Payment Collection',
  EmailAnAlertToThePatientAboutTheCardExpiry:
    'Email an alert message to the Patient about the card expiry',
  CopyPracticeAdminTheAlertNotificationAboutCardExpiry:
    'Copy Practice Admin the alert notification about card expiry',
  IAgreeTextReceipt: 'I Agree Text Receipt',
  PaymentLinkCommunicationTemplate: 'Payment Link Communication Template',
  CCEmailsForPaymentLinks: 'CC emails for payment links'
};

export const PRACTICE_CONFIGURATION = {
  AllowPayNow: 'Allow Pay Now',
  PayNowWithNoLookUpFilelds: 'Pay Now with NO Lookup Field Configuration',
  SortingPreferencesPatient:
    'Sorting Preferences for the patient’s appointment grid in payment module',
  AlertPracticeCCExxpiresDays: 'Alert if Practice CC expires within days',
  ConfigureSendPaymentLinkPractice:
    'Configure Send Payment Link for this Practice',
};

export const PAY_NOW_WITH_NO_LOOK_UP_FIELDS = {
  PracticeHeaderContent: 'Practice Header Content',
  PatientID: 'Patient ID',
  MemberID: 'Member ID',
  SubscriberID: 'Subscriber ID',
  PatientFirstName: 'Patient First Name',
  PatientLastName: 'Patient Last Name',
  Phone: 'Phone',
  Email: 'Email',
  AppointmentDate: 'Appointment Date',
  Provider: 'Provider',
  Amount: 'Amount',
  PracticeFooterContent: 'Practice Footer Content',
};

export const AR_AUTOMATION_CONFIGURATION = {
  ApplyPaymentPromotion: 'Apply Payment Promotion',
};

export const PAYMENT_PLAN_CONFIGURATION = {
  DoNotProcess: 'Do Not Process',
  AdditionalServiceFeeForPaymentPlan: 'Additional Service Fee for Payment Plan',
  AllowPaymentPlanAdjustment: 'Allow Payment Plan Adjustment',
  AllowPaymentPlanExtension: 'Allow Payment Plan Extension',
  PaymentPlanReminderMessage: 'Payment Plan Reminder Message',
  PaymentPlanSuccessMessage: 'Payment Plan Success Message',
  PaymentPlanFailureMessage: 'Payment Plan Failure Message',
  SaveDigitalCopyOfSignedPaymentPlan:
    'Save Digital Copy of Signed Payment Plan',
  IAgreeTextReceipt: 'I Agree Text',
};

export const PRACTICE_ANALYTICS_CONFIGURATION = {
  TilesToShowOnTheDashboard: 'Tiles to show on the Dashboard',
  ReportsToShowOnTheDashboard: 'Reports to show on the Dashboard',
};
